const AbstractDojoRequestRecord = require('./AbstractDojoRequestRecord');

class DojoTerminalListRequestRecord extends AbstractDojoRequestRecord {
    constructor() {
        super(
            'GET',
            'pac/terminals'
        );
    }
}

module.exports = DojoTerminalListRequestRecord;
